import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1285d78f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=1285d78f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1285d78f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1285d78f')) {
      api.createRecord('1285d78f', component.options)
    } else {
      api.reload('1285d78f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1285d78f&scoped=true&", function () {
      api.rerender('1285d78f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25RdJoHRAjtN7/JS/comp/SearchFilterTokens.vue"
export default component.exports